export { App as default } from '@guiker/conversation-main-mfe'
